<template>
    <div class="modal modal_catalog" id="id_modal_catalog" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-dialog modal-full" role="document">
            <div class="modal-content">
                <div class="modal-header">

                    <div class="input-group mr-4">
                        <input type="search"
                            class="form-control input_search"
                            placeholder="Фильтр по назв. категории"
                            v-model="filter"
                            @keyup="applyFilter"
                        >
                    </div>

                    <button type="button" class="btn btn_lg btn_common btn_icononly" data-dismiss="modal"><i
                        class="f7-icons icon_lg"
                        @click.prevent="applyFilter">xmark</i></button>

                </div>
                <div class="modal-body">

                    <ul class="row modal_catalog_tree catalog_tree">
                        <div class="col-12 col-lg-3" v-if="items[0]">
                            <li v-for="(item, index) in items[0]">
                                <b><a :href="item.url" class="category">{{ item.title }}</a><a href="#" class="d-lg-none ml-2"><i
                                            class="f7-icons icon_sm" data-toggle="collapse"
                                            :data-target="'#id_collapse_' + '0_' + index">plus_rectangle</i></a></b>

                                <ul class="collapse dont-collapse-lg" :id="'id_collapse_' + '0_' + index">
                                    <li v-for="(subItem, subIndex) in item.children">
                                        <a :href="subItem.url">{{ subItem.title }}</a>
                                    </li>
                                </ul>
                            </li>
                        </div>
                        <div class="col-12 col-lg-3" v-if="items[1]">
                            <li v-for="(item, index) in items[1]">
                                <b><a :href="item.url" class="category">{{ item.title }}</a><a href="#" class="d-lg-none ml-2"><i
                                            class="f7-icons icon_sm" data-toggle="collapse"
                                            :data-target="'#id_collapse_' + '1_' + index">plus_rectangle</i></a></b>

                                <ul class="collapse dont-collapse-lg" :id="'id_collapse_' + '1_' + index">
                                    <li v-for="(subItem, subIndex) in item.children">
                                        <a :href="subItem.url">{{ subItem.title }}</a>
                                    </li>
                                </ul>
                            </li>
                        </div>
                        <div class="col-12 col-lg-3" v-if="items[2]">
                            <li v-for="(item, index) in items[2]">
                                <b><a :href="item.url" class="category">{{ item.title }}</a><a href="#" class="d-lg-none ml-2"><i
                                            class="f7-icons icon_sm" data-toggle="collapse"
                                            :data-target="'#id_collapse_' + '2_' + index">plus_rectangle</i></a></b>

                                <ul class="collapse dont-collapse-lg" :id="'id_collapse_' + '2_' + index">
                                    <li v-for="(subItem, subIndex) in item.children">
                                        <a :href="subItem.url">{{ subItem.title }}</a>
                                    </li>
                                </ul>
                            </li>
                        </div>
                        <div class="col-12 col-lg-3" v-if="items[3]">
                            <li v-for="(item, index) in items[3]">
                                <b><a :href="item.url" class="category">{{ item.title }}</a><a href="#" class="d-lg-none ml-2"><i
                                            class="f7-icons icon_sm" data-toggle="collapse"
                                            :data-target="'#id_collapse_' + '3_' + index">plus_rectangle</i></a></b>

                                <ul class="collapse dont-collapse-lg" :id="'id_collapse_' + '3_' + index">
                                    <li v-for="(subItem, subIndex) in item.children">
                                        <a :href="subItem.url">{{ subItem.title }}</a>
                                    </li>
                                </ul>
                            </li>
                        </div>
                    </ul>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data: function () {
        return {
            categories: [],
            filtered: [],
            filter: '',
        };
    },
    methods: {
        applyFilter() {
            let filter = this.filter.toLowerCase();
            let result = [];
            let categories = [...this.categories];

            if (this.filter) {
                for (let i = 0; i < categories.length; i++) {
                    result[i] = [...categories[i].filter(item => {
                        let children = item.children.filter(child => child.title.toLowerCase().indexOf(filter) !== -1);

                        return children.length || item.title.toLowerCase().indexOf(filter) !== -1;
                    })];
                }

                for (let i = 0; i < result.length; i++) {
                    for (let j = 0; j < result[i].length; j++) {
                        result[i][j] = {
                            ...result[i][j],
                            children: [...result[i][j].children.filter(child => child.title.toLowerCase().indexOf(filter) !== -1)]
                        }
                    }
                }
            } else {
                result = categories;
            }

            this.filtered = result;
        },
    },
    computed: {
        items() {
            return this.filtered;
        }
    },
    mounted: function () {
        axios.get("/ajax/catalog/menu").then((request) => {
            if (
                typeof request.data.success != "undefined" &&
                request.data.success
            ) {
                this.categories = request.data.items;
                this.filtered = request.data.items;
            }
        });
    },
};
</script>
